export default __webpack_public_path__ + "static/media/twitter-icon.618294ee.svg";